<template>
  <div class="view-dialog">
    <el-dialog :title="dialogName" :visible.sync="viewDialogShow" width="90%" :before-close="dialogClose">
      <!-- 柱状图 -->
      <div id="myChart" ref="chart" style="height: 60vh; width: 100%; margin: 0 auto"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ['viewDialogShow', 'tabSelectName', 'viewDialogData', 'courseScoreAnalysisDialogType'],
  data() {
    return {
      chart: null, // ECharts 实例
      dialogName: "",
    }
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
    }, 200);
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    // 销毁图例
    clearChart() {
      if (
        this.chart != null &&
        this.chart != undefined &&
        this.chart != ""
      ) {
        this.chart.dispose();
      }
    },
    initChart() {
      if (this.chart) {
        this.chart.dispose(); // 销毁之前的实例
      };

      // 总分分布
      if (this.tabSelectName == 'third') {
        this.dialogName = '总分分布视图';
        this.totalScoreDistributionInit();
      };
      // 各科成绩分析-分数区间
      if (this.tabSelectName == 'fourth' && this.courseScoreAnalysisDialogType == 'fourth-score') {
        this.dialogName = '分数区间视图';
        this.courseScoreAnalysisScoreInit();
      };
      // 各科成绩分析-指标
      if (this.tabSelectName == 'fourth' && this.courseScoreAnalysisDialogType == 'fourth-index') {
        this.dialogName = '指标视图';
        this.courseScoreAnalysisIndexInit();
      };
      // 班级名次排行
      if (this.tabSelectName == 'sixth') {
        this.dialogName = '班级名次排行视图';
        this.classRankInit();
      };
      // 年级名次排行
      if (this.tabSelectName == 'seventh') {
        this.dialogName = '年级名次排行视图';
        this.gradeRankInit();
      };
    },
    totalScoreDistributionInit() {
      this.chart = echarts.init(this.$refs.chart);

      // 提取所有分数段并排序以确保顺序一致
      const scoreRanges = [...new Set(this.viewDialogData.flatMap(item => Object.keys(item.branchSegments || {})))].sort((a, b) => parseInt(a.replace(/[^\d]/g, ''), 10) - parseInt(b.replace(/[^\d]/g, ''), 10));

      // 分离“全级”和其他班级的数据
      const allGrade = this.viewDialogData.find(item => item.classId === -1);
      const classes = this.viewDialogData.filter(item => item.classId !== -1);

      // 构建图例数据（不包括“全级”）
      const legendData = classes.map(item => item.className);

      // 构建系列数据
      const seriesData = [
        ...legendData.map(className => ({
          name: className,
          type: 'bar',
          stack: 'total',
          data: scoreRanges.map(range => {
            const classData = classes.find(c => c.className === className);
            return (classData && classData.branchSegments ? classData.branchSegments[range] : null) || 0;
          }),
          emphasis: {
          focus: 'series'
        },
        })),
        // 添加“全级”的数据作为最后一条
        {
          name: '全级',
          type: 'bar',
          stack: 'total',
          data: scoreRanges.map(range => (allGrade && allGrade.branchSegments ? allGrade.branchSegments[range] : null) || 0),
          itemStyle: {
            color: 'rgba(0,0,0,0.2)' // 设置透明度或颜色以区分
          }
        }
      ];

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [...legendData, '全级']
        },
        xAxis: {
          type: 'value',
          name: '人数'
        },
        yAxis: {
          type: 'category',
          data: scoreRanges,
          name: '分数段'
        },
        series: seriesData
      };

      this.chart.setOption(option);
    },
    // 各科成绩分析分数视图初始化
    courseScoreAnalysisScoreInit() {
      this.chart = echarts.init(this.$refs.chart);

      const scoreData = this.viewDialogData.map(course => ({
        name: course.courseName,
        segments: course.branchSegments
      }));

      // 获取所有分数段
      const segmentLabels = Object.keys(scoreData[0].segments).reverse();

      // 构建series数据
      const seriesData = segmentLabels.map((label, index) => ({
        name: label,
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          position: 'inside'
        },
        emphasis: {
          focus: 'series'
        },
        data: scoreData.map(course => course.segments[label])
      }));

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: segmentLabels
        },
        xAxis: {
          type: 'category',
          data: scoreData.map(course => course.name),
          axisLabel: { interval: 0, rotate: 0 }, // 强制显示所有标签并旋转45度
          name: '科目',
        },
        yAxis: {
          type: 'value',
          name: '人数'
        },
        series: seriesData
      };

      this.chart.setOption(option);
    },
    // 各科成绩分析指标视图初始化
    courseScoreAnalysisIndexInit() {
      this.chart = echarts.init(this.$refs.chart);

      // 定义需要展示的指标及其对应的属性名
      const indicators = [
        { scoreRange: '考试人数', range: 'examNumber' },
        { scoreRange: '平均分', range: 'averageScore' },
        { scoreRange: '不及格人数', range: 'failCount' },
        { scoreRange: '及格人数', range: 'passCount' },
        { scoreRange: '合格率', range: 'passRate' },
        { scoreRange: '优良人数', range: 'excellentCount' },
        { scoreRange: '优良率', range: 'excellentRate' },
        { scoreRange: '最高分', range: 'highestScore' },
        { scoreRange: '最低分', range: 'lowestScore' }
      ];

      // 构建series数据
      const seriesData = indicators.map(indicator => ({
        name: indicator.scoreRange,
        type: 'bar',
        data: this.viewDialogData.map(course => course[indicator.range]),
        emphasis: {
          focus: 'series'
        },
      }));

      // 构建ECharts选项
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: indicators.map(indicator => indicator.scoreRange)
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.viewDialogData.map(course => course.courseName),
          axisLabel: { interval: 0, rotate: 0 }, // 强制显示所有标签并旋转45度
          name: '科目',
        },
        yAxis: {
          type: 'value',
          name: '数值'
        },
        series: seriesData
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
    // 班级视图初始化
    classRankInit() {
      this.chart = echarts.init(this.$refs.chart);

      // 提取所有课程名称用于x轴
      const allCourses = new Set();
      this.viewDialogData.forEach(cls => {
        cls.scoreRankContrastDTOList.forEach(student => {
          student.courseInfoList.forEach(course => allCourses.add(course.courseName));
        });
      });

      // 创建一个包含所有课程名称的数组，并保持顺序
      const courseNames = Array.from(allCourses).sort();

      // 整理数据
      const seriesData = [];
      const xAxisData = []; // 用于存储每个学生的名字

      this.viewDialogData.forEach(cls => {
        cls.scoreRankContrastDTOList.forEach(student => {
          // 添加学生名字到x轴数据
          if (!xAxisData.includes(student.className + student.studentName)) {
            xAxisData.push(student.className + student.studentName);
          }

          // 对于每个学生，遍历所有课程并填充数据或用0代替缺失值
          courseNames.forEach((course, index) => {
            const score = student.courseInfoList.find(c => c.courseName === course)?.score || 0;
            if (seriesData[index] === undefined) {
              seriesData[index] = {
                name: course,
                type: 'bar',
                data: [],
                emphasis: {
                  focus: 'series'
                },
              };
            }
            seriesData[index].data.push(score);
          });
        });
      });

      // 构建ECharts选项
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: courseNames
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisLabel: { interval: 0, rotate: 0 }, // 强制显示所有标签并旋转45度
          name: '学生',
        },
        yAxis: {
          type: 'value',
          name: '分数'
        },
        series: seriesData,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
    // 年级视图初始化
    gradeRankInit() {
      this.chart = echarts.init(this.$refs.chart);

      const courseNames = [...new Set(this.viewDialogData.flatMap(student => student.courseInfoList.map(course => course.courseName)))];
      const students = this.viewDialogData.map(student => student.className + student.studentName);

      const seriesData = courseNames.map(courseName => ({
        name: courseName,
        type: 'bar',
        data: students.map(student => {
          const studentData = this.viewDialogData.find(s => s.className + s.studentName === student);
          const scoreInfo = (studentData && studentData.courseInfoList) ?
            studentData.courseInfoList.find(course => course.courseName === courseName) : null;
          const score = scoreInfo ? scoreInfo.score : '-';
          return typeof score !== 'undefined' && score !== null ? score : '-';
        }),
        emphasis: {
          focus: 'series'
        },
      }));

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: courseNames
        },
        xAxis: {
          type: 'category',
          data: students,
          axisLabel: { interval: 0, rotate: 0 }, // 强制显示所有标签并旋转45度
          name: '学生',
        },
        yAxis: {
          type: 'value',
          name: '分数',
        },
        series: seriesData
      };

      this.chart.setOption(option);
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:viewDialogShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./viewDialog.scss";
</style>